var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}}),(_vm.$root.loading)?_c('div',{staticClass:"mt-5"},[_c('img',{attrs:{"height":"100px","src":"/loading.gif","alt":"Loading..."}})]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }